export default "__VITE_ASSET__Do5X_aPz__"